export default __webpack_public_path__ + "static/media/conteudo_extra_20_32.aed6d03f.jpg";